import type { ChangeBillingAddressPayload } from './BillingAddressForm';

export interface BillingAddressField {
	label: string;
	name: keyof ChangeBillingAddressPayload;
	placeholder: string;
	value?: string;
	isRequired: boolean;
}

export const getBillingAddressFields = (user: any): BillingAddressField[] => [
	{
		name: 'firstName',
		label: 'First Name',
		placeholder: 'eg Max',
		value: user?.invoiceAddress.firstName || user?.firstName,
		isRequired: true,
	},
	{
		name: 'lastName',
		label: 'Last Name',
		placeholder: 'eg Mustermann',
		value: user?.invoiceAddress.lastName || user?.lastName,
		isRequired: true,
	},
	{
		name: 'street',
		label: 'Street and house number',
		placeholder: 'e.g. Bahnstraße 1',
		value: user?.invoiceAddress.street,
		isRequired: true,
	},
	{
		name: 'postalCode',
		label: 'Postal Code',
		placeholder: '00000',
		value: user?.invoiceAddress.areaCode,
		isRequired: true,
	},
	{
		name: 'city',
		label: 'City',
		placeholder: 'e.g. Berlin',
		value: user?.invoiceAddress.city,
		isRequired: true,
	},
	{
		name: 'country',
		label: 'Country',
		placeholder: 'Select country',
		value: user?.invoiceAddress.country,
		isRequired: true,
	},
	{
		name: 'institution',
		label: 'Institution',
		placeholder: 'e.g. Primary School Berlin',
		value: user?.invoiceAddress.institution,
		isRequired: false,
	},
];
